'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIVE_EDITING_POPUP_ID = exports.LIVE_EDITING_POPUP_ID = 'remoteUsers';


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/liveEditing/liveEditingUtilConstants.js
// module id = 475
// module chunks = 0